enum InvoicePurpose {
    MANUAL = 'manual',
    SUBSCRIPTION = 'subscription',
}

export default InvoicePurpose;
